import * as React from 'react'
const InformationIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M12 22a10 10 0 117.07-2.93A10 10 0 0112 22zm0-19.09a9.08 9.08 0 108.4 5.61 9.08 9.08 0 00-4.92-4.92A9 9 0 0012 2.91z" className="-secondary-color" fill="#d7dae0"/>
      <path d="M12.91 5.64a.91.91 0 11-.91-.91.91.91 0 01.91.91zm-.45 12.72h1.81a.48.48 0 01.46.46.45.45 0 01-.14.32.42.42 0 01-.32.13H9.73a.42.42 0 01-.32-.13.45.45 0 01-.14-.32.48.48 0 01.46-.46h1.82v-8.18H9.73a.46.46 0 01-.32-.13.45.45 0 01-.14-.32.48.48 0 01.46-.46H12a.48.48 0 01.46.46z" className="-primary-color" fill="#a5aab8" fillRule="evenodd"/>
    </svg>
    
  )
}

export default InformationIcon